module.exports = __webpack_public_path__ + "img/m-header-bg.a645634e.jpg";